<template>
    <div class="rr-builder-modal" uk-modal>
        <div class="rr-builder-modal__dialog uk-modal-dialog">
            <a class="rr-builder-modal__close uk-modal-close-default" uk-close></a>

            <div class="rr-builder-modal__header uk-modal-header">
                <h2 class="rr-builder-modal__title uk-modal-title">{{ $t('rubinred.content.builder.editModal.title', primaryLocale) }} #{{ index+1 }}</h2>
            </div>

            <div class="uk-modal-body">
                <div uk-grid>
                    <div class="uk-width-1-1">
                        <ul class="rr-builder-modal__tab" uk-tab>
                            <li class="uk-active"><a>{{ $t('rubinred.content.builder.editModal.tab_general', primaryLocale) }}</a></li>
                            <li><a>{{ $t('rubinred.content.builder.editModal.tab_background', primaryLocale) }}</a></li>
                            <li><a>{{ $t('rubinred.content.builder.editModal.tab_design', primaryLocale) }}</a></li>
                            <li><a>{{ $t('rubinred.content.builder.editModal.tab_row', primaryLocale) }}</a></li>
                        </ul>
                        <ul class="rr-builder-modal__switcher uk-switcher">
                            <!--General Options-->
                            <li>
                                <form class="rr-builder-form uk-form-stacked">
                                    <fieldset class="uk-fieldset">
                                        <div class="rr-builder-form__row">
                                            <label class="uk-form-label">{{ $t('rubinred.content.builder.edit.columns_valign', primaryLocale) }}</label>
                                            <div class="uk-form-controls uk-width-1-1">
                                                <select class="uk-select" v-model="blockValign">
                                                    <option value="top">top</option>
                                                    <option value="middle">middle</option>
                                                    <option value="bottom">bottom</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="rr-builder-form__row">
                                            <label class="uk-form-label">{{ $t('rubinred.content.builder.edit.columns_reverse', primaryLocale) }}</label>
                                            <div class="rr-builder-form__radio uk-form-controls">
                                                <label><input class="uk-radio" type="radio" id="reverse_no" name="reverse" v-model="blockReverse" v-bind:value="false"> {{ $t('rubinred.content.builder.edit.no', primaryLocale) }}</label>
                                                <label><input class="uk-radio" type="radio" id="reverse_yes" name="reverse" v-model="blockReverse" v-bind:value="true"> {{ $t('rubinred.content.builder.edit.yes', primaryLocale) }}</label>
                                            </div>
                                        </div>
                                        <div class="rr-builder-form__row">
                                            <label class="uk-form-label">{{ $t('rubinred.content.builder.edit.columns_collapse', primaryLocale) }}</label>
                                            <div class="rr-builder-form__radio uk-form-controls">
                                                <label><input class="uk-radio" type="radio" id="collapsed_no" name="collapsed" v-model="blockCollapse" v-bind:value="false"> {{ $t('rubinred.content.builder.edit.no', primaryLocale) }}</label>
                                                <label><input class="uk-radio" type="radio" id="collapsed_yes" name="collapsed" v-model="blockCollapse" v-bind:value="true"> {{ $t('rubinred.content.builder.edit.yes', primaryLocale) }}</label>
                                            </div>
                                        </div>
                                        <div class="rr-builder-form__row">
                                            <label class="uk-form-label">{{ $t('rubinred.content.builder.edit.hide_small', primaryLocale) }}</label>
                                            <div class="rr-builder-form__radio uk-form-controls">
                                                <label><input class="uk-radio" type="radio" id="mobile_hidden_no" name="mobile_hidden"  v-model="blockHiddenSmall" v-bind:value="false"> {{ $t('rubinred.content.builder.edit.no', primaryLocale) }}</label>
                                                <label><input class="uk-radio" type="radio" id="mobile_hidden_yes" name="mobile_hidden" v-model="blockHiddenSmall" v-bind:value="true"> {{ $t('rubinred.content.builder.edit.yes', primaryLocale) }}</label>
                                            </div>
                                        </div>
                                        <div class="rr-builder-form__row">
                                            <label class="uk-form-label">{{ $t('rubinred.content.builder.edit.center_small', primaryLocale) }}</label>
                                            <div class="rr-builder-form__radio uk-form-controls">
                                                <label><input class="uk-radio" type="radio" id="mobile_center_no" name="mobile_center"  v-model="blockCenterSmall" v-bind:value="false"> {{ $t('rubinred.content.builder.edit.no', primaryLocale) }}</label>
                                                <label><input class="uk-radio" type="radio" id="mobile_center_yes" name="mobile_center" v-model="blockCenterSmall" v-bind:value="true"> {{ $t('rubinred.content.builder.edit.yes', primaryLocale) }}</label>
                                            </div>
                                        </div>
                                    </fieldset>
                                </form>
                            </li>
                            <!--Background-->
                            <li>
                                <form class="rr-builder-form uk-form-stacked">
                                    <fieldset class="uk-fieldset">
                                        <div class="rr-builder-form__row uk-margin">
                                            <label class="uk-form-label">{{ $t('rubinred.content.builder.edit.background_color', primaryLocale) }}</label>
                                            <div class="uk-form-controls">
                                                <div class="rr-builder-form__color uk-width-1-1">
                                                    <span class="rr-builder-form__color-sample" :style="{ backgroundColor: blockBackground }"></span>
                                                    <input class="rr-builder-form__color-input uk-input" type="text" placeholder="Hex Color" v-model="blockBackground">
                                                </div>
                                            </div>
                                        </div>
                                        <hr/>
                                        <div class="rr-builder-form__row uk-margin">
                                            <label class="uk-form-label">{{ $t('rubinred.content.builder.edit.background_image', primaryLocale) }}</label>
                                            <div class="uk-form-controls">
                                                <div class="rr-builder-form__color uk-width-1-1">
                                                    <input class="rr-builder-form__color-input uk-input" type="text" v-model="blockBackgroundImage">
                                                    <a class="uk-button uk-button-default" @click="media">
                                                        {{ $t('rubinred.content.builder.editModal.select_img', primaryLocale) }}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="uk-child-width-1-2@m uk-grid-small" uk-grid>
                                            <div>
                                                <div class="rr-builder-form__row">
                                                    <label class="uk-form-label">{{ $t('rubinred.content.builder.edit.background_position', primaryLocale) }}</label>
                                                    <div class="uk-form-controls uk-width-1-1">
                                                        <select class="uk-select" v-model="blockBackgroundPosition">
                                                            <option value="left top">left top</option>
                                                            <option value="left center">left center</option>
                                                            <option value="left bottom">left bottom</option>
                                                            <option value="center top">center top</option>
                                                            <option value="center center">center center</option>
                                                            <option value="center bottom">center bottom</option>
                                                            <option value="right top">right top</option>
                                                            <option value="right center">right center</option>
                                                            <option value="right bottom">right bottom</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="rr-builder-form__row">
                                                    <label class="uk-form-label">{{ $t('rubinred.content.builder.edit.background_size', primaryLocale) }}</label>
                                                    <div class="uk-form-controls uk-width-1-1">
                                                        <select class="uk-select" v-model="blockBackgroundSize">
                                                            <option value="auto">auto</option>
                                                            <option value="cover">cover</option>
                                                            <option value="contain">contain</option>
                                                            <option value="initial">initial</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="rr-builder-form__row">
                                                    <label class="uk-form-label">{{ $t('rubinred.content.builder.edit.background_repeat', primaryLocale) }}</label>
                                                    <div class="uk-form-controls uk-width-1-1">
                                                        <select class="uk-select" v-model="blockBackgroundRepeat">
                                                            <option value="no-repeat">no-repeat</option>
                                                            <option value="repeat-x">repeat-x</option>
                                                            <option value="repeat-y">repeat-y</option>
                                                            <option value="repeat">repeat</option>
                                                            <option value="initial">initial</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="rr-builder-form__row">
                                                    <label class="uk-form-label">{{ $t('rubinred.content.builder.edit.background_attachment', primaryLocale) }}</label>
                                                    <div class="uk-form-controls uk-width-1-1">
                                                        <select class="uk-select" v-model="blockBackgroundAttachment">
                                                            <option value="scroll">scroll</option>
                                                            <option value="fixed">fixed</option>
                                                            <option value="initial">initial</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>
                                </form>
                            </li>
                            <!--Design Options-->
                            <li>
                                <form class="rr-builder-form uk-form-stacked">
                                    <fieldset class="uk-fieldset">
                                        <div class="rr-builder-form__row">
                                          <label class="uk-form-label">Auto padding</label>
                                          <p>Usa i padding predefiniti per le sections</p>
                                          <div class="uk-child-width-1-2@m uk-grid-small uk-margin-top" uk-grid>
                                            <div>
                                              <label class="uk-form-label">Padding Top</label>
                                              <div class="uk-form-controls uk-width-1-1">
                                                <select class="uk-select" v-model="blockPaddingTopClass">
                                                  <option value="">None</option>
                                                  <option value="uk-section-top-xxsmall">xxsmall (20px)</option>
                                                  <option value="uk-section-top-xsmall">xsmall (40px)</option>
                                                  <option value="uk-section-top-small">small (60px)</option>
                                                  <option value="uk-section-top">normal (80px)</option>
                                                  <option value="uk-section-top-medium">medium (100px)</option>
                                                  <option value="uk-section-top-large">large (120px)</option>
                                                  <option value="uk-section-top-xlarge">xlarge (140px)</option>
                                                  <option value="uk-section-top-xxlarge">xxlarge (160px)</option>
                                                </select>
                                              </div>
                                            </div>
                                            <div>
                                              <label class="uk-form-label">Padding Bottom</label>
                                              <div class="uk-form-controls uk-width-1-1">
                                                <select class="uk-select" v-model="blockPaddingBottomClass">
                                                  <option value="">None</option>
                                                  <option value="uk-section-bottom-xxsmall">xxsmall (20px)</option>
                                                  <option value="uk-section-bottom-xsmall">xsmall (40px)</option>
                                                  <option value="uk-section-bottom-small">small (60px)</option>
                                                  <option value="uk-section-bottom">normal (80px)</option>
                                                  <option value="uk-section-bottom-medium">medium (100px)</option>
                                                  <option value="uk-section-bottom-large">large (120px)</option>
                                                  <option value="uk-section-bottom-xlarge">xlarge (140px)</option>
                                                  <option value="uk-section-bottom-xxlarge">xxlarge (160px)</option>
                                                </select>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="rr-builder-form__row">
                                            <label class="uk-form-label">{{ $t('rubinred.content.builder.edit.css_box', primaryLocale) }}</label>
                                            <div class="uk-alert uk-alert-primary uk-margin-remove-top">{{$t('rubinred.content.builder.editModal.values_message', primaryLocale)}}</div>
                                            <div class="rr-builder-cssbox">
                                                <div class="rr-builder-cssbox__prop rr-builder-cssbox__prop_margin">
                                                    <span class="rr-builder-cssbox__label">{{ $t('rubinred.content.builder.edit.margin', primaryLocale) }}</span>
                                                    <div class="rr-builder-cssbox__input-wrapper rr-builder-cssbox__input-wrapper_top">
                                                        <input type="text" placeholder="0px" class="uk-width-1-1 rr-builder-cssbox__input uk-input" v-model="blockMarginTop">
                                                    </div>
                                                    <div class="rr-builder-cssbox__input-wrapper rr-builder-cssbox__input-wrapper_right">
                                                        <input type="text" placeholder="0px" class="uk-width-1-1 rr-builder-cssbox__input uk-input" v-model="blockMarginRight">
                                                    </div>
                                                    <div class="rr-builder-cssbox__input-wrapper rr-builder-cssbox__input-wrapper_bottom">
                                                        <input type="text" placeholder="0px" class="uk-width-1-1 rr-builder-cssbox__input uk-input" v-model="blockMarginBottom">
                                                    </div>
                                                    <div class="rr-builder-cssbox__input-wrapper rr-builder-cssbox__input-wrapper_left">
                                                        <input type="text" placeholder="0px" class="uk-width-1-1 rr-builder-cssbox__input uk-input" v-model="blockMarginLeft">
                                                    </div>

                                                    <div class="rr-builder-cssbox__prop rr-builder-cssbox__prop_border">
                                                        <span class="rr-builder-cssbox__label">{{ $t('rubinred.content.builder.edit.border', primaryLocale) }}</span>
                                                        <div class="rr-builder-cssbox__input-wrapper rr-builder-cssbox__input-wrapper_top">
                                                            <input type="text" placeholder="0px" class="uk-width-1-1 rr-builder-cssbox__input uk-input" v-model="blockBorderTop">
                                                        </div>
                                                        <div class="rr-builder-cssbox__input-wrapper rr-builder-cssbox__input-wrapper_right">
                                                            <input type="text" placeholder="0px" class="uk-width-1-1 rr-builder-cssbox__input uk-input" v-model="blockBorderRight">
                                                        </div>
                                                        <div class="rr-builder-cssbox__input-wrapper rr-builder-cssbox__input-wrapper_bottom">
                                                            <input type="text" placeholder="0px" class="uk-width-1-1 rr-builder-cssbox__input uk-input" v-model="blockBorderBottom">
                                                        </div>
                                                        <div class="rr-builder-cssbox__input-wrapper rr-builder-cssbox__input-wrapper_left">
                                                            <input type="text" placeholder="0px" class="uk-width-1-1 rr-builder-cssbox__input uk-input" v-model="blockBorderLeft">
                                                        </div>

                                                        <div class="rr-builder-cssbox__prop rr-builder-cssbox__prop_padding">
                                                            <span class="rr-builder-cssbox__label">{{ $t('rubinred.content.builder.edit.padding', primaryLocale) }}</span>
                                                            <div class="rr-builder-cssbox__input-wrapper rr-builder-cssbox__input-wrapper_top">
                                                                <input type="text" placeholder="0px" class="uk-width-1-1 rr-builder-cssbox__input uk-input" v-model="blockPaddingTop">
                                                            </div>
                                                            <div class="rr-builder-cssbox__input-wrapper rr-builder-cssbox__input-wrapper_right">
                                                                <input type="text" placeholder="0px" class="uk-width-1-1 rr-builder-cssbox__input uk-input" v-model="blockPaddingRight">
                                                            </div>
                                                            <div class="rr-builder-cssbox__input-wrapper rr-builder-cssbox__input-wrapper_bottom">
                                                                <input type="text" placeholder="0px" class="uk-width-1-1 rr-builder-cssbox__input uk-input" v-model="blockPaddingBottom">
                                                            </div>
                                                            <div class="rr-builder-cssbox__input-wrapper rr-builder-cssbox__input-wrapper_left">
                                                                <input type="text" placeholder="0px" class="uk-width-1-1 rr-builder-cssbox__input uk-input" v-model="blockPaddingLeft">
                                                            </div>

                                                            <div class="rr-builder-cssbox__prop rr-builder-cssbox__prop_content">{{ $t('rubinred.content.builder.edit.content', primaryLocale) }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="uk-child-width-1-2@m uk-grid-small uk-margin-top" uk-grid>
                                            <div>
                                                <div class="rr-builder-form__row">
                                                    <label class="uk-form-label">{{ $t('rubinred.content.builder.edit.border_color', primaryLocale) }}</label>
                                                    <div class="uk-form-controls">
                                                        <div class="rr-builder-form__color uk-width-1-1">
                                                            <span class="rr-builder-form__color-sample" :style="{ backgroundColor: blockBorderColor }"></span>
                                                            <input class="rr-builder-form__color-input uk-input" type="text" placeholder="Hex Color" v-model="blockBorderColor">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="rr-builder-form__row">
                                                    <label class="uk-form-label">{{ $t('rubinred.content.builder.edit.border_style', primaryLocale) }}</label>
                                                    <div class="uk-form-controls uk-width-1-1">
                                                        <select class="uk-select" v-model="blockBorderStyle">
                                                            <option value="none">None</option>
                                                            <option value="solid">Solid</option>
                                                            <option value="dashed">Dashed</option>
                                                            <option value="dotted">Dotted</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="rr-builder-form__row">
                                                    <label class="uk-form-label">{{ $t('rubinred.content.builder.edit.border_radius', primaryLocale) }}</label>
                                                    <div class="uk-form-controls uk-width-1-1">
                                                        <input class="uk-input" type="text" placeholder="0px" v-model="blockBorderRadius">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>
                                </form>
                            </li>
                            <!--Row Options-->
                            <li>
                                <form class="rr-builder-form uk-form-stacked">
                                    <fieldset class="uk-fieldset">
                                        <div class="uk-alert uk-alert-primary"><slot name="modal-row-message"></slot></div>
                                        <div class="rr-builder-form__row">
                                            <label class="uk-form-label">{{ $t('rubinred.content.builder.edit.row_background', primaryLocale) }}</label>
                                            <div class="uk-form-controls">
                                                <div class="rr-builder-form__color uk-width-1-1">
                                                    <span class="rr-builder-form__color-sample" :style="{ backgroundColor: rowBackground }"></span>
                                                    <input class="rr-builder-form__color-input uk-input" type="text" placeholder="Hex Color" v-model="rowBackground">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="rr-builder-form__row">
                                            <label class="uk-form-label">{{ $t('rubinred.content.builder.edit.row_wrap', primaryLocale) }}</label>
                                            <div class="rr-builder-form__radio uk-form-controls">
                                                <label><input class="uk-radio" type="radio" id="wrap_no" name="wrap" v-model="blockWrap" v-bind:value="false"> {{ $t('rubinred.content.builder.edit.no', primaryLocale) }}</label>
                                                <label><input class="uk-radio" type="radio" id="wrap_yes" name="wrap" v-model="blockWrap" v-bind:value="true"> {{ $t('rubinred.content.builder.edit.yes', primaryLocale) }}</label>
                                            </div>
                                        </div>
                                    </fieldset>
                                </form>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="rr-builder-modal__footer rr-builder-modal__footer_first-left uk-modal-footer uk-text-right">
                <button type="button" class="uk-button uk-button-text" @click="resetModal">
                    {{ $t('rubinred.content.builder.editModal.reset', primaryLocale) }}
                </button>
                <button type="button" class="uk-button uk-button-default uk-modal-close">
                    {{ $t('rubinred.content.builder.editModal.cancel', primaryLocale) }}
                </button>
                <button type="button" class="uk-button uk-button-primary" @click="hideModal">
                    {{ $t('rubinred.content.builder.editModal.save', primaryLocale) }}
                </button>
            </div>
        </div>
    </div>
</template>

<style lang="less">
    @import (reference) "~less/app";
    @import "~rubinred/content/less/rubinred-builder";

    /* form */
    .rr-builder-form {

        .rr-builder-form__row > .uk-form-label{
            font-weight: 700;
        }

        .rr-builder-form__row  + .rr-builder-form__row {
            margin-top: @builder-utility-margin;
        }

        /* radio */
        &__radio {
            label:not(:last-child) {
                margin-right: @builder-utility-margin;
            }
        }

        /* color */
        &__color {
            display: inline-flex;
            border: 1px solid #ddd;

            &-sample {
                width: @form-height;
                height: @form-height;
                border-right: 1px solid #ddd;
            }

            &-input {
                border: none!important;
                flex: 1;

                &:focus {
                    background-color: @form-background!important;
                }
            }

            &-picker {
                margin-left: 3px;
                width: 30px!important;
                height: 30px!important;
                border: none!important;
                padding: 0!important;
                line-height: 1!important;
                background-color: transparent!important;
                -webkit-appearance: none;
            }

            input[type="color"]::-webkit-color-swatch-wrapper {
                padding: 0;
            }
            input[type="color"]::-webkit-color-swatch {
                border: none;
            }

            .uk-button {
                border-left: 1px solid #ddd;
                background-color: #ebebeb;
            }
        }
    }

    /* css box */
    .rr-builder-cssbox {
        @ccs-box-font-size: @text-small-font-size;
        @ccs-box-input-font-size: @form-small-font-size;
        @css-box-spacing: 10px;
        @css-box-input-width-small: 35px;
        @css-box-input-width: 44px;
        @css-box-margin-background: #ffffff;
        @css-box-margin-border: 1px dashed shade(@global-border, 10%);
        @css-box-border-background: #f9f9f9;
        @css-box-border-border: 1px solid shade(@global-border, 10%);
        @css-box-padding-background: shade(#f9f9f9, 7%);
        @css-box-padding-border: 1px solid shade(@global-border, 10%);
        @css-box-content-background: #ffffff;
        @css-box-content-border: 1px solid shade(@global-border, 10%);

        width: 100%;
        position: relative;
        display: block;

        @media (min-width: @breakpoint-large) {
            width: 80%;
            margin: 0 auto;
        }

        &__prop {
            padding: 36px ~"calc(@{css-box-input-width-small} + @{css-box-spacing})";
            position: relative;
            font-size: @ccs-box-font-size;
            border: 1px solid shade(@global-border, 10%);

            @media (min-width: @breakpoint-medium) {
                padding: 36px ~"calc(@{css-box-input-width} + @{css-box-spacing})";
            }

            &.rr-builder-cssbox__prop_margin {
                border: @css-box-margin-border;
                background-color: @css-box-margin-background;
            }

            &.rr-builder-cssbox__prop_border {
                border: @css-box-border-border;
                background-color: @css-box-border-background;
            }

            &.rr-builder-cssbox__prop_padding {
                border: @css-box-padding-border;
                background-color: @css-box-padding-background;
            }

            &.rr-builder-cssbox__prop_content {
                border: @css-box-content-border;
                background-color: @css-box-content-background;
                text-align: center;
                padding: 5px;
            }
        }

        &__label {
            position: absolute;
            top: 3px;
            left: 3px;
            font-size: @ccs-box-font-size;
            line-height: 1;
        }

        &__input-wrapper {
            width: @css-box-input-width-small;
            position: absolute;

            @media (min-width: @breakpoint-medium) {
                width: @css-box-input-width;
            }

            &.rr-builder-cssbox__input-wrapper_top {
                top: @css-box-spacing/2;
                left: 50%;
                transform: translate(-50%, 0);
            }
            &.rr-builder-cssbox__input-wrapper_right {
                top: 50%;
                right: @css-box-spacing/2;
                transform: translate(0, -50%);
            }
            &.rr-builder-cssbox__input-wrapper_bottom {
                bottom: @css-box-spacing/2;
                left: 50%;
                transform: translate(-50%, 0);
            }
            &.rr-builder-cssbox__input-wrapper_left {
                top: 50%;
                left: @css-box-spacing/2;
                transform: translate(0, -50%);
            }
        }

        &__input {
            font-size: @ccs-box-input-font-size!important;
            padding: 5px 3px!important;
            height: auto!important;
            line-height: 1!important;
            border-color: shade(@global-border, 15%)!important;
        }
    }
</style>

<script>
  import PrimaryLocaleAwareComponent from "rubinred/content/js/mixins/PrimaryLocaleAwareComponent";

  export default {
    mixins: [PrimaryLocaleAwareComponent],
    data() {
      return {
        modal: null,
        block: null,
        index: null,
        rowBackground: 'transparent',
        blockBackground: 'transparent',
        blockBackgroundImage: 'none',
        blockBackgroundPosition: 'left top',
        blockBackgroundSize: 'auto',
        blockBackgroundRepeat: 'no-repeat',
        blockBackgroundAttachment: 'initial',
        blockBorderTop: '0px',
        blockBorderRight: '0px',
        blockBorderBottom: '0px',
        blockBorderLeft: '0px',
        blockBorderColor: '#ffffff',
        blockBorderStyle: 'none',
        blockBorderRadius: '0px',

        blockValign: 'top',
        blockWrap: false,
        blockReverse: false,
        blockCollapse: false,
        blockHiddenSmall: false,
        blockCenterSmall: false,
        blockPaddingTopClass: '',
        blockPaddingBottomClass: '',
        blockPaddingTop: '0px',
        blockPaddingRight: '0px',
        blockPaddingBottom: '0px',
        blockPaddingLeft: '0px',
        blockMarginTop: '0px',
        blockMarginRight: 'auto',
        blockMarginBottom: '0px',
        blockMarginLeft: 'auto',
      }
    },

    created() {
      this.$root.$on('open-edit-block-modal', this.showModal);
      this.$root.$on('close-edit-block-modal', this.hideModal);
    },

    mounted() {
      this.modal = window.App.UIkit.modal(this.$el);

      window.setBackgroundBlock = (url) => {
        this.setBackgroundBlock(url);
      }
    },

    computed: {
        blockBackgroundUrl (){
          if (this.blockBackgroundImage && this.blockBackgroundImage !== 'none' ) {
            return `url(' ${this.blockBackgroundImage} ')`
          }
          return 'none';
        },
    },

    methods: {
      setBackgroundBlock(url) {
        this.blockBackgroundImage = url;
      },

      media() {
        window.open(window.App.get('builder.endpoints.media'));
      },

      showModal(block) {
        this.index = block.index;
        this.block = block.block;
        this.rowBackground = this.block.styleBackgroundRow.backgroundColor;

        this.blockBackground = this.block.styleBlockWrapper.backgroundColor;
        this.blockBackgroundImage = this.block.blockBackgroundImage;
        this.blockBackgroundPosition = this.block.styleBlockWrapper.backgroundPosition;
        this.blockBackgroundSize = this.block.styleBlockWrapper.backgroundSize;
        this.blockBackgroundRepeat = this.block.styleBlockWrapper.backgroundRepeat;
        this.blockBackgroundAttachment = this.block.styleBlockWrapper.backgroundAttachment;

        this.blockBorderTop = this.block.styleBlockWrapper.borderTop;
        this.blockBorderRight = this.block.styleBlockWrapper.borderRight;
        this.blockBorderBottom = this.block.styleBlockWrapper.borderBottom;
        this.blockBorderLeft = this.block.styleBlockWrapper.borderLeft;
        this.blockBorderColor = this.block.styleBlockWrapper.borderColor;
        this.blockBorderStyle = this.block.styleBlockWrapper.borderStyle;
        this.blockBorderRadius = this.block.styleBlockWrapper.borderRadius;

        this.blockMarginTop = this.block.styleBlockWrapper.marginTop;
        this.blockMarginRight = this.block.styleBlockWrapper.marginRight;
        this.blockMarginBottom = this.block.styleBlockWrapper.marginBottom;
        this.blockMarginLeft = this.block.styleBlockWrapper.marginLeft;

        this.blockValign = this.block.blockValign;
        this.blockWrap = this.block.blockWrap;
        this.blockReverse = this.block.blockReverse;
        this.blockCollapse = this.block.blockCollapse;
        this.blockHiddenSmall = this.block.blockHiddenSmall;
        this.blockCenterSmall = this.block.blockCenterSmall;
        this.blockPaddingTopClass = this.block.blockPaddingTopClass;
        this.blockPaddingBottomClass = this.block.blockPaddingBottomClass;
        this.blockPaddingTop = this.block.styleBlock.paddingTop;
        this.blockPaddingTop = this.block.styleBlock.paddingTop;
        this.blockPaddingRight = this.block.styleBlock.paddingRight;
        this.blockPaddingBottom = this.block.styleBlock.paddingBottom;
        this.blockPaddingLeft = this.block.styleBlock.paddingLeft;

        this.modal.show();
      },

      resetModal() {
        this.rowBackground = 'transparent';
        this.blockBackground = 'transparent';
        this.blockBackgroundImage = 'none';
        this.blockBackgroundPosition = 'left top';
        this.blockBackgroundSize = 'auto';
        this.blockBackgroundRepeat = 'no-repeat';
        this.blockBackgroundAttachment = 'initial';
        this.blockBorderTop = '0px';
        this.blockBorderRight = '0px';
        this.blockBorderBottom = '0px';
        this.blockBorderLeft = '0px';
        this.blockBorderColor = '#ffffff';
        this.blockBorderStyle = 'none';
        this.blockBorderRadius = '0px';
        this.blockValign = 'top';
        this.blockWrap = false;
        this.blockReverse = false;
        this.blockCollapse = false;
        this.blockHiddenSmall = false;
        this.blockCenterSmall = false;
        this.blockPaddingTopClass = '';
        this.blockPaddingBottomClass = '';
        this.blockPaddingTop = '0px';
        this.blockPaddingRight = '0px';
        this.blockPaddingBottom = '0px';
        this.blockPaddingLeft = '0px';
        this.blockMarginTop = '0px';
        this.blockMarginRight = 'auto';
        this.blockMarginBottom = '0px';
        this.blockMarginLeft = 'auto';
      },

      hideModal() {
        this.block.styleBackgroundRow.backgroundColor = this.rowBackground;

        this.block.styleBlockWrapper = {
          backgroundColor: this.blockBackground,
          backgroundImage: this.blockBackgroundUrl,
          backgroundPosition: this.blockBackgroundPosition,
          backgroundSize: this.blockBackgroundSize,
          backgroundRepeat: this.blockBackgroundRepeat,
          backgroundAttachment: this.blockBackgroundAttachment,
          borderTop: this.blockBorderTop,
          borderRight: this.blockBorderRight,
          borderBottom: this.blockBorderBottom,
          borderLeft: this.blockBorderLeft,
          borderColor: this.blockBorderColor,
          borderStyle: this.blockBorderStyle,
          borderRadius: this.blockBorderRadius,
          marginTop: this.blockMarginTop,
          marginRight: this.blockMarginRight,
          marginBottom: this.blockMarginBottom,
          marginLeft: this.blockMarginLeft,
        };

        this.block.blockPaddingTopClass = this.blockPaddingTopClass;
        this.block.blockPaddingBottomClass = this.blockPaddingBottomClass;
        this.block.blockValign = this.blockValign;
        this.block.blockWrap = this.blockWrap;
        this.block.blockReverse = this.blockReverse;
        this.block.blockCollapse = this.blockCollapse;
        this.block.blockHiddenSmall = this.blockHiddenSmall;
        this.block.blockCenterSmall = this.blockCenterSmall;
        this.block.styleBlock = {
          paddingTop: this.blockPaddingTop,
          paddingRight: this.blockPaddingRight,
          paddingBottom: this.blockPaddingBottom,
          paddingLeft: this.blockPaddingLeft,
        };

        this.block.blockBackgroundImage = this.blockBackgroundImage;

        // let blockSettings = {
        //   index: index,
        //   blockValign: 'top',
        //   blockWrap: false,
        //   blockCollapse: false,
        //   blockHiddenSmall: false,
        //
        //   styleBackgroundBlock: {
        //     backgroundColor: 'transparent',
        //   },
        //   styleBackgroundRow: {
        //     backgroundColor: 'transparent',
        //   },
        //   styleBlock: {
        //     paddingTop: '0px',
        //     paddingRight: '0px',
        //     paddingBottom: '0px',
        //     paddingLeft: '0px',
        //     marginTop: '0px',
        //     marginRight: '0px',
        //     marginBottom: '0px',
        //     marginLeft: '0px',
        //   }
        // };
        // this.$root.$emit('set-dirty', blockSettings);
        this.$root.$emit('set-dirty');

        this.modal.hide();
      }
    },
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/imbotex/extensions/rubinred/content/assets/js/components/BuilderEditBlockModal.vue